import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Avatar } from '@material-ui/core';
import { useStatus } from '~/hooks';
import * as lib from '~/dependencies';
import * as actions from '~/store/actions';
import * as NuacomComponent from '~/components';
import MandatoryCallTagging from '~/screens/DisplayCall/MandatoryCallTagging';
import { VideoState } from '~/store/reducers/callCurrent';
import { getInitials } from '~/helpers';
import BoxUpdater from './BoxUpdater';
import { AppBarDiv, LeftSide, RightSide, Settings } from './styles';

export default function Header(props) {
  const { children, center, headerColor, location } = props;
  const { pathname } = location;

  const dispatch = useDispatch();
  const history = useHistory();

  const [hasUpdate, setHasUpdate] = useState(false);

  const [{ statusColor }, setStatus] = useStatus();

  const userInfo = useSelector(state => state.auth);
  const videoCall = useSelector(state => state.callCurrent.video);
  const { data: currentCalls, session: activeSession } = useSelector(
    state => state.callCurrent
  );

  const {
    version,
    showUpdaterMessage,
    OS,
    newVersionAvailable,
    status: systemStatus,
  } = useSelector(state => state.system);

  const showUpdateNotification =
    hasUpdate &&
    activeSession === null &&
    currentCalls &&
    currentCalls?.length === 0;

  useEffect(() => {
    setStatus(systemStatus);
  }, [setStatus, systemStatus]);

  useEffect(() => {
    navigator.mediaDevices.ondevicechange = () => {
      dispatch(actions.phoneDeviceSetup());
    };
  }, [dispatch]);

  useEffect(() => {
    (function checkForUpdate() {
      if (newVersionAvailable) {
        if (Object.keys(newVersionAvailable).length > 0) {
          const { new_version, os } = newVersionAvailable;
          const newRelease =
            (typeof new_version === 'undefined' ? version : new_version) !==
            version;
          const path = pathname.match(/^\/app(\/)?$/g);
          const updateOS = os === 'all' || os === OS;

          if (newRelease && path && updateOS && showUpdaterMessage) {
            setHasUpdate(true);
          } else {
            setHasUpdate(false);
          }
        }
      }
    })();
  }, [OS, pathname, showUpdaterMessage, newVersionAvailable, version]);

  useEffect(() => {
    // Reset last access conversation once the user navigate away from conversations screen
    if (!pathname?.includes('/app/conversations')) {
      dispatch(actions.setConversationLastReadIndex(0));
      dispatch(actions.setConversationSearch(undefined));
    }
  }, [dispatch, pathname]);

  return (
    <>
      <AppBarDiv position="static" headerColor={headerColor}>
        <LeftSide>
          <Settings
            data-test-id="settings"
            className="settings-react-tour"
            bgcolor={statusColor}
            overlap="circular"
            badgeContent=" "
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}>
            <Avatar onClick={() => history.push('/app/config')}>
              <span>{getInitials(userInfo.user_name)}</span>
            </Avatar>
          </Settings>
        </LeftSide>
        <RightSide center={center}>{children}</RightSide>
      </AppBarDiv>

      {currentCalls?.length > 0 && <NuacomComponent.ActiveCall {...props} />}

      {videoCall && videoCall.state === VideoState.Initial ? (
        <NuacomComponent.VideoActiveCall {...videoCall} />
      ) : null}

      <MandatoryCallTagging />

      {showUpdateNotification && <BoxUpdater setHasUpdate={setHasUpdate} />}
    </>
  );
}

Header.defaultProps = {
  children: React.createElement('div'),
  center: false,
  headerColor: false,
  location: {},
};

Header.propTypes = {
  children: lib.PropTypes.node,
  center: lib.PropTypes.bool,
  headerColor: lib.PropTypes.bool,
  location: lib.PropTypes.instanceOf(Object),
};
